export default "<xo-common-component></xo-common-component>\n";